import { render } from "./Kakunin.vue?vue&type=template&id=1d19f9b6&scoped=true"
import script from "./Kakunin.vue?vue&type=script&lang=js"
export * from "./Kakunin.vue?vue&type=script&lang=js"

import "./Kakunin.vue?vue&type=style&index=0&id=1d19f9b6&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d19f9b6"]])

export default __exports__